import React, { useState } from "react";
import axios from 'axios';
import './Weather.css';
import FormattedDate from "./FormattedDate";
import TempConversion from "./TempConversion"
import Forecast from "./Forecast";

export default function Weather(props) {    
  let [weatherData, setWeatherData] = useState({ready : false})
  let [city, setCity] = useState(props.defaultCity);
  
  function showData(response) {
        setWeatherData({
            city: response.data.name,
            temp: Math.round(response.data.main.temp),
            desc: response.data.weather[0].description,
            humi: response.data.main.humidity,
            wind: Math.round(response.data.wind.speed),
            icon: `https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
            date: new Date(response.data.dt * 1000),
            coords: response.data.coord,
            ready: true
        })
    }

    function search() {
        let apiKey = "203fa770242fcd2b9555d832a88ea567";
        let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
        axios.get(apiUrl).then(showData);
    }

    function handleSubmit(event) {
        event.preventDefault(); 
        search();
    }

    function changeCity(event) {
        setCity(event.target.value);
    }

  if (weatherData.ready) {
        return (
        <div className="Weather">
            <div className="row">
                <div className="col">
                    <h3>Results for <strong className="text-capitalize">{weatherData.city}</strong></h3>
                    <FormattedDate date={weatherData.date}/>
                </div>
                <div className="col">
                    <form onSubmit={handleSubmit}>
                        <input
                            type="search"
                            placeholder="Type a city..."
                            className="btn btn-light text-start text-capitalize "
                            onChange={changeCity}
                        />
                        <input 
                            type="submit"
                            value="Search" 
                            className="btn btn-primary"
                        />
                    </form>
                </div>
            </div>
            <div className="row">
                <div className="col ">
                    <img src={weatherData.icon} alt={weatherData.desc}  className="d-inline"/>
                    <TempConversion cels={weatherData.temp}/>
                </div>
                <div className="col">
                <ul>
                    <li className="text-capitalize">{weatherData.desc}</li>
                    <li className="">Humidity: {weatherData.humi}%</li>
                    <li className="">Wind: {weatherData.wind}km/h</li>
                </ul>
                </div>
            </div>
            <div>
                <div className="row">
                    <Forecast coords={weatherData.coords} day={1}/>
                    <Forecast coords={weatherData.coords} day={2}/>
                    <Forecast coords={weatherData.coords} day={3}/>
                    <Forecast coords={weatherData.coords} day={4}/>
                    <Forecast coords={weatherData.coords} day={5}/>
                    <Forecast coords={weatherData.coords} day={6}/>
                    <Forecast coords={weatherData.coords} day={7}/>
                </div>
            </div>
        </div>
        );
    } else {
        search()
        return ("Loading...")
    }  
}